<div class="report-container house-rental">

    <ng-container>

        <app-report-sub-menu [menuList]="overViewMenu"
            (menuChangeValue)="menuChangeValue($event)"></app-report-sub-menu>
        <ng-container *ngIf="overViewLoading">
            <app-skeleton-loader [reportType]="chartView.overView" [height]="'150px'"></app-skeleton-loader>
        </ng-container>
        <div class="report-tabsection" id="{{ houseRentalMenuEnum.overview}}"
            [ngClass]="{ 'scroll': currentScroll === houseRentalMenuEnum.overview}">
            <div class="report-overview report-overview-2col" *ngIf="!overViewLoading">
                <app-overview-card
                [card_title]="sharedService.priceCalculation$() === sharedService.priceYearly ? 'reports.AnnuallyAverageRent' : 'reports.averageRentRate'" 
                [total_current]="overViewSummary?.avg_rent"
                [untillDate]="overViewSummary?.untillDate"
                [total_prev]="overViewSummary?.prev_avg_rent"
                [total_percentage]="overViewSummary?.totalaverage_rent"
                [uniType]="UnitTypeEnum.currencywithsqm"></app-overview-card>
                
                <app-overview-card
                [card_title]="'reports.highest_valued_rent_rate'" 
                [total_current]="overViewSummary?.highest_rent"
                [untillDate]="overViewSummary?.untillDate"
                [total_prev]="overViewSummary?.prev_highest_rent"
                [total_percentage]="overViewSummary?.totalhighest_rent"
                [neighborhood]="overViewSummary?.neighborhood"
                [uniType]="UnitTypeEnum.currencywithsqm"></app-overview-card>

                
            </div>
        </div>

        <div class="report-model">
            <div class="report-model-header">
                <div class="info">
                    <h3>{{sharedService.priceCalculation$() === sharedService.priceYearly ? ('reports.annual_rental_price_in' | translate) : ('reports.rental_price_in' | translate)}} {{(placeName | lowercase) | translate}} ({{CurrencyCode | translate}}/{{'reports.sqm_unit' | translate}})</h3>
                </div>

            </div>
            <ng-container  *ngIf="houserentalChart.length > 0; else chartNoRecords">
                <ng-container *ngIf="houserentalChartLoading">
                    <app-skeleton-loader [reportType]="chartView.barChart"></app-skeleton-loader>
                </ng-container>
                <ng-container *ngIf="!houserentalChartLoading">
                    <app-report-charts [data]="houserentalChart" [chartType]="chartView.varianceIndicatorsChart"
                        [name]="'houserentalChart'"></app-report-charts>

                </ng-container>
            </ng-container>
            <ng-template #chartNoRecords>
                <div class="data_unavail">
                    {{"reports.no_record_found" | translate}}
                </div>
            </ng-template>
        </div>


        <!-- Average Rent Unit Wise -->
        <div class="report-tabsection"
            [ngClass]="{ 'scroll': currentScroll === houseRentalMenuEnum.averageRentUnitWise}"
            id="{{ houseRentalMenuEnum.averageRentUnitWise }}">

            <app-report-year-dropdown [reportType]="'rental'"
                (selectedYear)="selectedYear($event)"></app-report-year-dropdown>


            <div class="report-model">

                

                <app-datatable-title [title]="sharedService.priceCalculation$() === sharedService.priceYearly ? 'reports.annual_average_rent_unit_wise' : 'reports.average_rent_unit_wise' " [count]="averageRentUnitWiseCount"  [countTitle]="'reports.totalUnits'"></app-datatable-title>

                <app-report-datatable
                    [showLoader]="!averageRentUnitWiseLoading"
                    [tableColumns]="averageRentUnitWiseColumns"
                    [dataLength]="averageRentUnitWiseCount"
                    [tableData]="averageRentUnitWisedata"
                    (pageEvent)="onPageEvent($event, houseRentalMenuEnum.averageRentUnitWise)"
                    (sort)="sortData($event, houseRentalMenuEnum.averageRentUnitWise)"
                    [allowExcelDownload]="true"
                    (excelDownload)="downloadExcel($event, 'rental')" [downloadLoading]="downloadLoading"
                    [showEstaterText]="true"
                    [resetPaginator]="resetPaginator"
                    [currentPageIndex]="currentPageIndex"
                    [reportSectionTitle]="'Average Rent Unit Wise'"
                >
                </app-report-datatable>


            </div>
        </div>


    </ng-container>

</div>
